import React, { Component } from 'react';
import config from "./../config.json";

class RolCard extends Component {

  state = {
    values: this.props.values,
    users: this.props.users,
  }

  onClick = (event) => {
    this.props.parentCallback(this.state.values);
    event.preventDefault();
  }

  onDeleteClick = (event) => {
    this.props.parentDeleteCallback(this.state.values);
    event.preventDefault();
  }

  getImageSource = (resim) => {
    if (!resim) {
      return config.blankPhoto;
    }
    return String(resim).startsWith('data:image') ? resim : config.imageEndpoint + resim;
  }

  render() {

    let filteredKullanici = Array.isArray(this.state.users)
      ? this.state.users.filter(
          (personel) =>
            personel.AktifMi === true &&
            Array.isArray(personel.Roller) &&
            personel.Roller.includes(this.state.values['RolId']
          )
        )
      : [];

    return <tr>
      <td>{this.state.values['Adi'] || this.state.values['adi']}</td>
      <td>
        <ul className="list-unstyled users-list m-0 avatar-group d-flex align-items-center">
          {filteredKullanici.map(tag => <li key={tag.KullaniciId}
            data-bs-toggle="tooltip"
            data-popup="tooltip-custom"
            data-bs-placement="top"
            className="avatar avatar-xs pull-up"
            title={tag.Ad + ' ' + tag.Soyad}>
            <img loading="lazy" src={this.getImageSource(tag.Resim)} alt="Avatar" className="rounded-circle" />
          </li>)}
        </ul>
      </td>

      <td>
        <div className="dropdown">
          <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
            <i className="bx bx-dots-vertical-rounded"></i>
          </button>
          <div className="dropdown-menu">
            <button className="dropdown-item" onClick={this.onClick} data-bs-toggle="modal"
              data-bs-target="#modalCenter">
              <i className="bx bx-edit-alt me-1"></i> Güncelle</button>
            <button className="dropdown-item" onClick={this.onDeleteClick}>
              <i className="bx bx-trash me-1"></i> Sil</button>
          </div>
        </div>
      </td>
    </tr>;
  }
}

export default RolCard;
